import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getIdToken } from '../../auth';
import { IRepositoryss,IResult, IPaging, INewRepository, IAccessRepository } from '../../types/Repositorys';
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState{
    paging: null | IPaging,
    result: IRepositoryss | any,
  
    results: IResult[] | any,
    repository: INewRepository | null,
    resultss: IAccessRepository | any
    error: null | any
}

const initialState: IState = {
    paging: null,
    result: '',
    results: [],
    resultss: null,
    repository: null,
    error: null
}

// console.log("Este es el token en el AdminRepositorySlice", token);
export const fetchPullRepositorys = createAsyncThunk(
    'fetchPullRepositorys',
    async (params: { Page: number, Take: number }) => {
        try {
            const token = getIdToken();
            const { Page, Take } = params;
            const response = await fetch(`${BASE_URL_ENDPOINT}/api/v2/repository?page=${Page}&take=${Take}`,{
                method: 'GET',
                headers: {
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': ` Bearer ${token}`}
            });
            console.log("Este es el token en el fetchPullRepositorys:",response);
            return await response.json();
        } catch (error) {
            console.log(error);
            throw error;
    }
} 
);



export const fetchSearchRepositorys = createAsyncThunk(
    'fetchSearchRepositorys',
async (name: string): Promise<any> => {
    try {
        const token = getIdToken();
        const response = await fetch(`${BASE_URL_ENDPOINT}/repository-ctx/api/v2/repository?page=1&take=100&name=${name}`,{
            method: 'GET',
            headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': ` Bearer ${token}`}
        });

        return await response.json();
    } catch (error) {
        console.log(error);
        throw error;
    }
}
);


const RepositorysSlice = createSlice({
    name: "repositorysSlice",
    initialState,
    reducers: {

    },
   
    extraReducers(builder) {
        builder.addCase(
            fetchPullRepositorys.fulfilled, (state, action) => {
                state.paging = action.payload.paging;
                console.log("state-paging:",state.paging);
                state.result = action.payload.result;
                console.log("state-result-Admin-Repositorys****:",state.result);
                state.error = null;
            }
        );
        builder.addCase(
            fetchPullRepositorys.rejected, (state, action) => {
                state.error = action.payload;
            }
        );
        builder.addCase(
            fetchSearchRepositorys.fulfilled, (state, action) => {
                state.paging = action.payload.paging;
                console.log("state-paging:",state.paging);
                state.result = action.payload.result;
                console.log("state-result-search-Admin-Repositorys****:",state.result);
                state.error = null;
            }
        );
        builder.addCase(
            fetchSearchRepositorys.rejected, (state, action) => {
                state.error = action.payload;
            }
        );
    },
});

export default RepositorysSlice.reducer;